import React from 'react';
import SvgArrow from '../../../../play-core/icons/Arrow';
import { Colors } from '../../../../play-core/styles/Colors';
import { jsx as _jsx } from "react/jsx-runtime";
const arrowSize = 24;
export const NowArrow = ({
  top,
  left = 0,
  centerHorizontally = false
}) => /*#__PURE__*/_jsx(SvgArrow, {
  orientation: "up",
  style: {
    fontSize: `${arrowSize}px`,
    color: Colors.WHITE,
    position: 'absolute',
    pointerEvents: 'none',
    top: `${top - 16}px`,
    left: centerHorizontally ? `calc(50% - ${arrowSize / 2}px)` : `${left - arrowSize / 2}px`
  }
});